"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Square(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19 3c.522 0 1.055.191 1.432.568.377.377.568.91.568 1.432v14c0 .522-.191 1.055-.568 1.432-.377.377-.91.568-1.432.568H5c-.522 0-1.055-.191-1.432-.568C3.191 20.055 3 19.522 3 19V5c0-.522.191-1.055.568-1.432C3.945 3.191 4.478 3 5 3zm0 2H5v14h14V5zm-5.147 2v1.627h-.192l-.263.01c-.772.052-1.403.281-1.894.687-.544.451-.871 1.078-.98 1.88.528-.538 1.196-.807 2.002-.807.866 0 1.554.31 2.065.93.51.62.765 1.436.765 2.447 0 .648-.14 1.233-.42 1.757-.28.524-.677.932-1.19 1.224-.512.292-1.092.437-1.74.437-1.047 0-1.894-.364-2.539-1.093-.645-.73-.967-1.703-.967-2.92v-.71l.008-.356c.04-.935.241-1.77.604-2.505a4.486 4.486 0 0 1 1.757-1.921c.763-.453 1.648-.682 2.655-.687h.329zm-1.928 4.983a1.576 1.576 0 0 0-1.443.91v.601l.007.241c.028.547.156.982.383 1.307.26.372.624.558 1.094.558.424 0 .767-.168 1.029-.503.262-.335.393-.769.393-1.302 0-.542-.132-.98-.397-1.313-.264-.332-.62-.499-1.066-.499z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Square;
